import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Table, Button, Form, Row, Col, Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import Pagination from 'react-js-pagination';
import moment from 'moment';
import { LOPDAOTAOLIENTUC_TRIENKHAI_API } from '../../../utils/apiUrl';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { Get } from '../../../utils/httpProvider';
import {
    objectShowNumber,
    trangThaiDotTuyenSinhValue,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT
} from '../../../utils/define';

const LopDaoTaoLienTuc = () => {
    const history = useHistory();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    const filterPayload = {
        pageIndex: page,
        pageSize: pageSize,
        keyword: valueSearch || ''
    };

    const { data: pagedData, isLoading } = useQuery(
        ['lopDaoTaoLienTucPaging', page, pageSize, valueSearch],
        () => Get(LOPDAOTAOLIENTUC_TRIENKHAI_API.GET_PAGING, null, filterPayload),
        { keepPreviousData: true }
    );

    const listLop = pagedData?.data?.$values || pagedData?.data || [];
    const totalRecords = pagedData?.totalRecords || 0;

    const getTrangThaiBadge = (st) => {
        switch (st) {
            case trangThaiDotTuyenSinhValue.sapMo: return <Badge variant="secondary">Sắp mở</Badge>;
            case trangThaiDotTuyenSinhValue.dangMo: return <Badge variant="success">Đang mở</Badge>;
            case trangThaiDotTuyenSinhValue.daDong: return <Badge variant="dark">Đã đóng</Badge>;
            case trangThaiDotTuyenSinhValue.tamDung: return <Badge variant="warning">Tạm dừng</Badge>;
            default: return <Badge variant="light">Mới tạo</Badge>;
        }
    };

    return (
        <div className="p-3">
            <Card className="shadow-sm border-0">
                <Card.Header className="bg-white py-3">
                    <Row className="align-items-center justify-content-between">
                        <Col md={6}>
                            <h5 className="mb-0 text-primary font-weight-bold">
                                <i className="fas fa-layer-group mr-2"></i>
                                Quản Lý Triển Khai Đào Tạo Liên Tục
                            </h5>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="table-responsive">
                        <Table striped bordered hover className="mb-0 align-middle">
                            <thead className="thead-light text-nowrap">
                                <tr>
                                    <th style={{ width: 50 }} className="text-center">#</th>
                                    <th style={{ minWidth: 280 }}>Tên khóa học / Lớp</th>
                                    <th style={{ minWidth: 130 }} className="text-center">Số quyết định</th>
                                    <th style={{ minWidth: 120 }} className="text-center">Ngày khai giảng</th>
                                    <th style={{ minWidth: 120 }} className="text-center">Ngày bế giảng</th>
                                    <th style={{ minWidth: 100 }} className="text-center">Số lượng HV</th>
                                    <th style={{ minWidth: 100 }} className="text-center">Số lượng GV</th>
                                    <th style={{ minWidth: 110 }} className="text-right">Học phí</th>
                                    <th style={{ minWidth: 110 }} className="text-center">Trạng thái</th>
                                    <th className="text-center" style={{ width: 130 }}>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={10} className="text-center py-4">Đang tải danh sách lớp học...</td></tr>
                                ) : listLop.length === 0 ? (
                                    <tr><td colSpan={10} className="text-center py-4 text-muted">Không tìm thấy lớp đào tạo liên tục nào.</td></tr>
                                ) : (
                                    listLop.map((lop, idx) => (
                                        <tr key={lop.id}>
                                            <td className="text-center">{(page - 1) * pageSize + idx + 1}</td>
                                            <td className="font-weight-bold" style={{ whiteSpace: 'normal', minWidth: 280 }}>
                                                <a
                                                    href={`#${URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_PATH}/${lop.id}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        history.push(`${URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_PATH}/${lop.id}`);
                                                    }}
                                                    className="text-primary"
                                                >
                                                    {lop.tenKhoaHoc}
                                                </a>
                                            </td>
                                            <td className="text-center">{lop.soQuyetDinh || "—"}</td>
                                            <td className="text-center">{lop.ngayKhaiGiang ? moment(lop.ngayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : "—"}</td>
                                            <td className="text-center">{lop.ngayBeGiang ? moment(lop.ngayBeGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : "—"}</td>
                                            <td className="text-center">
                                                <Badge variant="info">
                                                    {lop.soLuongHocVienThucTe || 0} HV
                                                </Badge>
                                            </td>
                                            <td className="text-center">
                                                <Badge variant="secondary">
                                                    {lop.soLuongGiangVien || 0} GV
                                                </Badge>
                                            </td>
                                            <td className="text-right font-weight-bold">
                                                {lop.hocPhi ? lop.hocPhi.toLocaleString('vi-VN') + " đ" : "Miễn phí"}
                                            </td>
                                            <td className="text-center">{getTrangThaiBadge(lop.trangThaiDotTuyenSinh)}</td>
                                            <td className="text-center">
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => history.push(`${URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_PATH}/${lop.id}`)}
                                                >
                                                    <i className="fas fa-arrow-right mr-1"></i> Triển khai
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
                {totalRecords > 0 && (
                    <Card.Footer className="bg-white d-flex justify-content-between align-items-center py-2">
                        <div className="d-flex align-items-center">
                            <span className="text-muted mr-3">Tổng số: {totalRecords} lớp học</span>
                            <Form.Control
                                as="select"
                                size="sm"
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setPage(1);
                                }}
                                style={{ width: '110px', borderRadius: '4px' }}
                            >
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <Pagination
                            itemClass="page-item"
                            linkClass="page-link"
                            activePage={page}
                            itemsCountPerPage={pageSize}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={(p) => setPage(p)}
                        />
                    </Card.Footer>
                )}
            </Card>
        </div>
    );
};

export default LopDaoTaoLienTuc;
